module.exports = __webpack_public_path__ + "static/assets/bd958d7ca22677585d8275f6edb725dc.svg";